// Constants pour les statuts de validation
export const VALIDATION_STATUS = {
  DRAFT: 0,
  PENDING: 1,
  VALIDATED: 2,
  REJECTED: 3,
  EXECUTED: 4
};

// Helper pour obtenir le libellé du statut
export const getValidationStatusLabel = (status) => {
  switch (status) {
    case VALIDATION_STATUS.DRAFT:
      return 'Brouillon';
    case VALIDATION_STATUS.PENDING:
      return 'En attente';
    case VALIDATION_STATUS.VALIDATED:
      return 'Validé';
    case VALIDATION_STATUS.REJECTED:
      return 'Rejeté';
    case VALIDATION_STATUS.EXECUTED:
      return 'Exécuté';
    default:
      return 'Inconnu';
  }
};
// Helper pour obtenir la classe CSS en fonction du statut
export const getValidationStatusClass = (status) => {
  switch (status) {
    case VALIDATION_STATUS.DRAFT:
      return 'badge bg-secondary bg-opacity-10 text-secondary border border-secondary border-opacity-25';
    case VALIDATION_STATUS.PENDING:
      return 'badge bg-warning bg-opacity-10 text-warning border border-warning border-opacity-25';
    case VALIDATION_STATUS.VALIDATED:
      return 'badge bg-success bg-opacity-10 text-success border border-success border-opacity-25';
    case VALIDATION_STATUS.REJECTED:
      return 'badge bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25';
    case VALIDATION_STATUS.EXECUTED:
      return 'badge bg-blue bg-opacity-10 text-blue border border-blue border-opacity-25';
    default:
      return 'badge bg-gray bg-opacity-10 text-gray border border-gray border-opacity-25';
  }
};

// Helper pour obtenir l'icône en fonction du statut
export const getValidationStatusIcon = (status) => {
  switch (status) {
    case VALIDATION_STATUS.DRAFT:
      return '✏️';
    case VALIDATION_STATUS.PENDING:
      return '⏳';
    case VALIDATION_STATUS.VALIDATED:
      return '✅';
    case VALIDATION_STATUS.REJECTED:
      return '❌';
    case VALIDATION_STATUS.EXECUTED:
      return '🚀';
    default:
      return '❓';
  }
};